import React from "react";

const AccountSettings = () => {
  return <div>AccountSettings</div>;
};

export default AccountSettings;
